/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_invite_page_contract_duration = /** @type {(inputs: {}) => string} */ () => {
	return `Duración del contrato`
};

const en_invite_page_contract_duration = /** @type {(inputs: {}) => string} */ () => {
	return `Contract duration`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const invite_page_contract_duration = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.invite_page_contract_duration(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("invite_page_contract_duration", locale)
	if (locale === "es") return es_invite_page_contract_duration(inputs)
	return en_invite_page_contract_duration(inputs)
};
export { invite_page_contract_duration as "invite.page.contract_duration" }